import { IoLogoInstagram, IoLogoWhatsapp, IoCallOutline } from 'react-icons/io5';
import { BsSnapchat } from "react-icons/bs";
import { TbBrandTiktok } from "react-icons/tb";




export const sideNavData = [
  {
    id: 1,
    text: 'سناب شات',
    icon: BsSnapchat,
    href: 'https://www.snapchat.com/add/w5.lounge',
  },
  {
    id: 2,
    text: 'انستجرام',
    icon: IoLogoInstagram,
    href: 'https://www.instagram.com/w5.lounge',
  },
  {
    id: 3,
    text: 'تيك توك',
    icon: TbBrandTiktok,
    href: 'https://www.tiktok.com/@w5.lounge',
  },
  {
    id: 4,
    text: 'واتساب',
    icon: IoLogoWhatsapp,
    href: 'https://api.whatsapp.com/send/?phone=966580055531',
  },
  {
    id: 5,
    text: 'أتصل بنا',
    icon: IoCallOutline,
    href: 'tel:0580055531',
  },
]

export const data = [
    {
      id: 1,
      title: 'الفطور - Breakfast',
      image: '../../../img/list/breakfast.png',
      selected: false,
      items: [
        {
          id: 1,
          title: 'فول',
          titleEn: 'Fava Beans',
          description: 'فول مع الفلفل الاخضر ، والطماطم الطازجة، والبصل الأحمر، والطحينة، وعصير الليمون، والبابريكا الحلوة، والملح، والثوم الطازج، والكمون، وزيت الزيتون.',
          image: '../../img/food/fava-beans.jpg',
          price: 10,
          calories: 374,
          available: true,
          selected: false,
        },
        {
          id: 2,
          title: 'فتة باذنجان',
          titleEn: 'Fatteh Eggplant',
          description: 'باذنجان مع الخبز العربي المقلي الزيادي، الطحينة عصير الليمون، الزبدة، الثوم الكمون والملح. زينه بالبقدونس واللوز المقلي وبذور الرمان الطازجة',
          image: '../../img/food/fatteh-eggplant.jpg',
          price: 14,
          calories: 320,
          available: true,
          selected: false,
        },
        {
          id: 3,
          title: 'حمص',
          titleEn: 'Hot Hommos',
          description: 'حمص مع طماطم طازجة ثوم طازج طماطم فلفل مبصق بصل أحمر كمون ملح زيت عباد الشمس عصير الليمون تزيين مع البقدونس الطازج',
          image: '../../img/food/hot-hommos.jpg',
          price: 14,
          calories: 400,
          available: true,
          selected: false,
        },
        {
          id: 4,
          title: 'عجة',
          titleEn: 'Eggah',
          description: 'ديس حار أريسا طماطم طازجة بيض زيت زيتون عباد الشمس زيت بابريكا ثوم وفلفل أسود. تزيين مع البقدونس الطازج',
          image: '../../img/food/eggah.jpg',
          price: 11,
          calories: 250,
          available: true,
          selected: false,
        },
        {
          id: 5,
          title: 'حصن تونسي',
          titleEn: 'Tunisian Plate',
          description: 'يقدم في وعاء خاص ويخلط مع عصير الليمون والجزر والبطاطس والطماطم والنعناع المجفف والفلفل الأخضر والبصل الأحمر والخيار وزيت الزيتون والفلفل الأسود يقدم مع لولو باندو على الجانب والبيض المقلي في الأعلى',
          image: '../../img/food/tunisian-plate.jpg',
          price: 8,
          calories: 300,
          available: true,
          selected: false,
        },
        {
          id: 6,
          title: 'بطاطا حاره',
          titleEn: 'Batata Harra',
          description: 'مكعبات البطاطس الطازجة مع عصير الليمون، دبس الفلفل، الملح، الثوم، والفلفل الحلو الساخن. تقدم في وعاء خاص مزين بالكزبرة وشريحة الليمون الطازجة',
          image: '../../img/food/batata-harra.jpg',
          price: 8,
          calories: 320,
          available: true,
          selected: false,
        },
        {
          id: 7,
          title: 'كرواسون بستاشيو',
          titleEn: 'Croissant Pistachio',
          description: 'كرواسون يقدم مع صلصة البستاشيو في الأعلى مع المكسرات البستاشيو المقرمشة',
          image: '../../img/food/croissant-pistachio.jpg',
          price: 19,
          calories: 400,
          available: true,
          selected: false,
        },
        {
          id: 8,
          title: 'فلافل',
          titleEn: 'Falafel',
          description: 'مكون من حمص وقول مفرومين مع كزيرة وبقدونس وبصل أحمر وثوم، متبل بالملح ومقدم مع كرمب مقرمش',
          image: '../../img/food/falafel.jpg',
          price: 19,
          calories: 350,
          available: true,
          selected: false,
        },
        {
          id: 9,
          title: 'سلطة حمص',
          titleEn: 'Hommos',
          description: 'حمص طازج محضر من الطحينة والملح وملح الليمون وزيت دوار الشمس وزيت الزيتون والثوم الطازج ومزين بحمص مسلوق',
          image: '../../img/food/hommos.jpg',
          price: 12,
          calories: 250,
          available: true,
          selected: false,
        },
        {
          id: 10,
          title: 'كروسون براتا سندوتش',
          titleEn: 'Buratta Sandwich',
          description: 'كرواسون سادة محشو بجبنة البوراتا الممزوجة بالريحان، وزيت الزيتون، والثوم الطازج، والفلفل الأسود، والملح، والكاجو، وأوراق النعناع، والروكا الصغيرة، والطماطم الطازجة. يقدم مع سلطة طازجة مكونة من روكا صغيرة، وفلفل أسود وملح وعصير ليمون وزيت زيتون وخس أيسبيرغ، وخس عادي، ومزينة بحبات الطماطم الكرزية من الأعلى',
          image: '../../img/food/buratta-sandwich.jpg',
          price: 20,
          calories: 450,
          available: true,
          selected: false,
        },
        {
          id: 11,
          title: 'كروسون تونا اسبيسي سندوتش',
          titleEn: 'Spicy Tuna Sandwich',
          description: 'ساندويتش تونة حارة ممزوجة بالعسل والخردل الأصفر والأوريغانو المجفف، زيت زيتون وخل التفاح وصوص السيراتشا وفلفل أسود وشرائح الهالابينو ممزوجة مع تونة W5 الخاصة بنا. يقدم مع سلطة طازجة مكونة من روكا صغيرة، وفلفل أسود، وملح، وعصير ليمون، وزيت زيتون، وخس أيسبيرغ، وخس عادي، ومزينة بحبات الطماطم الكرزية من الأعلى',
          image: '../../img/food/spicy-tuna-sandwich.jpg',
          price: 20,
          calories: 420,
          available: true,
          selected: false,
        },
        {
          id: 12,
          title: 'كرواسون شكولاته',
          titleEn: 'Croissant Chocolate',
          description: 'كرواسون سادة يُقدم مع صوص نوتيلا، ومغطى بمكس من اللوز والفستق الممزوجين بالسكر والزبدة وشراب الجلوكوز',
          image: '../../img/food/croissant-chocolate.jpg',
          price: 18,
          calories: 400,
          available: true,
          selected: false,
        },
        {
          id: 13,
          title: 'حلوم تشيز سندوتش',
          titleEn: 'Halloumi Cheese Sandwich',
          description: 'ساندويتش جبنة حلوم يقدم في خبز تشابانا الخاص، مع جبنة الحلوم الممزوجة بزيت الزيتون والزيتون الأسود يقدم مع جبنة بارميزان وأوراق الريحان والطماطم الطازجة والنعناع، جنب قطع البطاطس المقلية الخاصة',
          image: '../../img/food/halloumi-cheese-sandwich.jpg',
          price: 25,
          calories: 500,
          available: true,
          selected: false,
        },
        {
          id: 14,
          title: 'هوت دوج سندوتش',
          titleEn: 'Hotdog Beef Sandwich',
          description: 'ساندويتش سجق يقدم في خبز تشابانا الخاص، مع سجق أمريكي خاص ممزوج بالفلفل الأخضر والبصل الأحمر والفلفل الأحمر مزيج مع تتبيلة الدجاج الخاصة بنا، يُقدم مع قطع البطاطس المقلية الخاصة و الكاتشب',
          image: '../../img/food/hotdog-beef-sandwich.jpg',
          price: 27,
          calories: 550,
          available: true,
          selected: false,
        },
        {
          id: 15,
          title: 'كرواسون بلوز',
          titleEn: 'Croissant Almond',
          description: 'كرواسون مع البيض، يقدم مع بودرة اللوز، بودرة السكر، وشرائح اللوز',
          image: '../../img/food/croissant-almond.jpg',
          price: 18,
          calories: 380,
          available: true,
          selected: false,
        },
        {
          id: 16,
          title: 'حلوم مشوي',
          titleEn: 'Grilled Halloumi',
          description: 'جبنة حلوم مشوية طازجة تقدم مع طماطم طازجة، روكا صغيرة، وأوراق نعناع طازجة ممزوج بزيت الزيتون',
          image: '../../img/food/grilled-halloumi.jpg',
          price: 20,
          calories: 350,
          available: true,
          selected: false,
        },
        {
          id: 17,
          title: 'دجاج سندوتش بصوص السيزر',
          titleEn: 'Chicken Sandwich with Caesar Sauce',
          description: 'ساندوتش الدجاج يقدم في خبز سيابانا مع الدجاج، صلصة السيزر، الخس، لولو باندي، الطماطم الطازجة، الملح، الفلفل الأسود فلفل أسود، زيت دوار الشمس أوريغانو، وخل التفاح، يقدم مع قطع البطاطس المقلية الخاصة و الكاتشب',
          image: '../../img/food/chicken-caesar-sandwich.jpg',
          price: 27,
          calories: 600,
          available: true,
          selected: false,
        },
      ]
    },
    {
      id: 2,
      title: 'البيتزا - Pizza',
      image: '../../../img/list/pizza.png',
      selected: true,
      items: [
          {
              id: 2,
              title: 'بيتزا دجاج نابولي',
              titleEn: 'Napoli Chicken Pizza',
              description: 'عجينة البيتزا بطريقة دبليو فايف مع الصلصة الحمراء و قطع الدجاج',
              image: '../../img/food/Napoli.jpg',
              price: 42,
              calories: 420,
              available: true,
              selected: false,
          },
          {
              id: 3,
              title: 'هاواي بيتزا نابولي',
              titleEn: 'Hawaiian Napoli Pizza',
              description: 'بيتزا إيطالية مع الصلصة الحمراء و الاناناس و المورتديلا و البطاطس المقرمشة',
              image: '../../img/food/Hawaiian.jpg',
              price: 42,
              calories: 430,
              available: true,
              selected: false,
          },
          {
              id: 4,
              title: 'روما نابولي',
              titleEn: 'Roma Napoli',
              description: 'عجينة البيتزا مع صوص الطماطم الطازج مع البيكون و التين المجفف و جبنة بوراتا',
              image: '../../img/food/Roma.jpg',
              price: 44,
              calories: 420,
              available: true,
              selected: false,
          },
          {
              id: 5,
              title: 'بيتزا غلال البحر',
              titleEn: 'Seafood Pizza',
              description: 'عجينة البيتزا مع صلصة النابوليتان و مجموعة من صيد البحر',
              image: '../../img/food/Seafood.jpg',
              price: 44,
              calories: 420,
              available: true,
              selected: false,
          },
          {
              id: 6,
              title: 'ميكسكان نابولي',
              titleEn: 'Mexican Napoli',
              description: 'عجينة البيتزا مع صوص الطماطم الحمراء و اللحم المفروم و قطع الفلفل الحار',
              image: '../../img/food/Mexican.jpg',
              price: 42,
              calories: 420,
              available: true,
              selected: false,
          },
          {
              id: 7,
              title: 'فور تشيز نابولي',
              titleEn: 'Four Cheese Napoli',
              description: 'عجينة البيتزا مع الكريمة البيضاء و الجبنة المشكلة و ورق الريحان',
              image: '../../img/food/FourCheese.jpg',
              price: 43,
              calories: 420,
              available: true,
              selected: false,
          },
          {
              id: 8,
              title: 'بيبروني نابولي',
              titleEn: 'Pepperoni Napoli',
              description: 'بيتزا نابولي الشهيرة مع البيبروني الإيطالي و الصوص الحمراء',
              image: '../../img/food/Pepperoni.jpg',
              price: 42,
              calories: 430,
              available: true,
              selected: false,
          },
          {
              id: 9,
              title: 'بيتزا خضار مشكلة',
              titleEn: 'Mixed Vegetable Pizza',
              description: 'عجينة البيتزا مع الخضار المشكلة و الصلصة الحمراء و جبنة الموزاريلا',
              image: '../../img/food/Mixed.jpg',
              price: 40,
              calories: 420,
              available: true,
              selected: false,
          },
          {
              id: 10,
              title: 'بينكا بيتزا دجاج',
              titleEn: 'Bianca Chicken Pizza',
              description: 'كريمة طبخ و دجاج و مشروم و جبنة موتزريلا و جبنة بارميزان',
              image: '../../img/food/Bianca.jpg',
              price: 42,
              calories: 430,
              available: true,
              selected: false,
          },

      ]
    },
      {
    id: 3,
    title: 'الباستا - Pasta',
    image: '../../../img/list/pasta.png',
    selected: false,
    items: [
      {
        id: 11,
        title: 'روزيتو ترافل دجاج',
        titleEn: 'Chicken Truffle Risotto',
        description: 'أرز الريزتو الايطالي مع الصوص الترافل مع قطع فلفل اللوان مع زبدة نباتي وكريمة طبخ وجبنة بارميزان مع شرائح الدجاج',
        image: '../../img/food/risotto-truffle.jpg',
        price: 48,
        calories: 540,
        available: true,
        isNew: true,
        selected: false,
      },
      {
        id: 10,
        title: 'w5 دريتوس باستا',
        titleEn: 'w5 drittos pasta',
        description: 'صوص W5 الحار معا لحم ولبنه وفلفل حار وحلو و دوريتوس والجبنه البرميزان',
        image: '../../img/food/drittos.jpeg',
        price: 45,
        calories: 520,
        available: true,
        isNew: true,
        selected: false,
      },
      {
        id: 1,
        title: 'باستا أرابياتا',
        titleEn: 'Arrabbiata Pasta',
        description: 'مكرونة قلم، زيتون حلقات أسود، بصل أبيض، فلفل رومي أخضر، صلصة الطماطم، طماطم شيري، جبنة بارميزان، خبز بالثوم، بقدونس.',
        image: '../../img/food/Arrabbiata.jpg',
        price: 35,
        calories: 420,
        available: true,
        selected: false,
      },
      {
        id: 1,
        title: 'باستا أرابياتا دجاج',
        titleEn: 'Arrabbiata Pasta Chicken',
        description: 'صدور دجاج, مكرونة قلم، زيتون حلقات أسود، بصل أبيض، فلفل رومي أخضر، صلصة الطماطم، طماطم شيري، جبنة بارميزان، خبز بالثوم، بقدونس.',
        image: '../../img/food/arrabbiata-pasta-chicken.jpg',
        price: 39,
        calories: 420,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'باستا أرابياتا روبيان',
        titleEn: 'Arrabbiata Pasta Shrimp',
        description: 'روبيان، مكرونة قلم، زيتون حلقات أسود، بصل أبيض، فلفل رومي أخضر، صلصة الطماطم، طماطم شيري، جبنة بارميزان، خبز بالثوم، بقدونس.',
        image: '../../img/food/arrabbiata-pasta-shrimp.jpg',
        price: 40,
        calories: 450,
        available: true,
        selected: false,
      },
      {
        id: 3,
        title: 'بيستو باستا روبيان',
        titleEn: 'Pesto Pasta Shrimp',
        description: 'صوص بيستو، مكرونة فوزيلي، روبيان، جبنة بارميزان، كريمة الطبخ، مخزون الدجاج، طماطم شيري، خبز بالثوم، بقدونس.',
        image: '../../img/food/pesto-pasta-shrimp.jpg',
        price: 42,
        calories: 480,
        available: true,
        selected: false,
      },
      {
        id: 4,
        title: 'ترافل باستا دجاج',
        titleEn: 'Truffle Pasta Chicken',
        description: 'فيتوتشيني مع كريمة الطهي، الترافل، والمشروم الطازج، وتُقدَّم مع شرائح الخبز.',
        image: '../../img/food/Truffle.jpg',
        price: 40,
        calories: 430,
        available: true,
        selected: false,
      },
      {
        id: 5,
        title: 'بيستو باستا دجاج',
        titleEn: 'Pesto Pasta Chicken',
        description: 'فيوزيلي باستا مع صوص البيستو والدجاج، جبنة البارميزان، وتُقدَّم مع الخبز.',
        image: '../../img/food/Pesto.jpg',
        price: 40,
        calories: 400,
        available: true,
        selected: false,
      },
      {
        id: 6,
        title: 'كريسبي تشيكن باستا',
        titleEn: 'Crispy Chicken Pasta',
        description: 'بيني باستا مع صوص الطماطم وكريمة الطبخ، تُقدَّم مع جبنة البرميجان.',
        image: '../../img/food/Crispy.jpg',
        price: 42,
        calories: 470,
        available: true,
        selected: false,
      },
      {
        id: 7,
        title: 'تكساس باستا',
        titleEn: 'Texas Pasta',
        description: 'بيني باستا مع صوص التكساس الحار وكريمة الطبخ، تُقدَّم مع جبنة البارميزان وشرائح الخبز.',
        image: '../../img/food/Texas.jpg',
        price: 40,
        calories: 450,
        available: true,
        selected: false,
      },
      {
        id: 8,
        title: 'ألفريدو باستا',
        titleEn: 'Alfredo Pasta',
        description: 'فيتوتشيني مع صوص الألفريدو والمشروم، تُقدَّم مع جبنة البارميزان وشرائح الخبز.',
        image: '../../img/food/Alfredo.jpg',
        price: 40,
        calories: 430,
        available: true,
        selected: false,
      },
      {
        id: 9,
        title: 'لازانيا',
        titleEn: 'Lasagna',
        description: 'طبقات من مكرونه صوص اللحم جبنه موزاريلا جبنة البارميزان وصوص الباشاميل',
        image: '../../img/food/iftar-lasagna.jpg',
        price: 45,
        calories: 520,
        available: true,
        selected: false,
      },
    ]
  },
  {
    id: 4,
    title: 'السلطات - Salads',
    image: '../../../img/list/salat.png',
    selected: false,
    items: [
      {
        id: 1,
        title: 'روكا سلطة',
        titleEn: 'Rocca Salad',
        description: 'جرجير، بصل مكرمل، طماطم شيري، صوص بلسمك، وتُقدَّم مع خبز بالثوم.',
        image: '../../img/food/Rocca.jpg',
        price: 20,
        calories: 190,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'تبولة',
        titleEn: 'Tabbouleh',
        description: 'بقدونس، طماطم، بصل، نعناع، برغل، وخس.',
        image: '../../img/food/Tabbouleh.jpg',
        price: 20,
        calories: 200,
        available: true,
        selected: false,
      },
      {
        id: 3,
        title: ' سيزر سلطة سادة',
        titleEn: 'Caesar Salad Standard',
        description: ' خس بلدي، خس كابوتشا، طماطم شيري، جبنة بارميزان، كرتونز، صوص سيزر، زيتون أسود حلقات.',
        image: '../../img/food/caesar-salad-standard.jpg',
        price: 20,
        calories: 180,
        available: true,
        selected: false,
      },
      {
        id: 4,
        title: 'سيزر سلطة بالروبيان',
        titleEn: 'Shrimp Caesar Salad',
        description: 'خس بلدي، خس كابوتشا، طماطم شيري، جبنة بارميزان، كرتونز، صوص سيزر، زيتون أسود حلقات، روبيان.',
        image: '../../img/food/shrimp-caesar-salad.jpg',
        price: 27,
        calories: 200,
        available: true,
        selected: false,
      },
      {
        id: 5,
        title: ' سيزر سلط دجاج',
        titleEn: 'Caesar Chicken Salad',
        description: 'خس عربي وكابوتشا، خبز محمّص، زيتون أسود، صوص السيزر، جبنة البرميجان ودجاج مشوي.',
        image: '../../img/food/Caesar.jpg',
        price: 25,
        calories: 170,
        available: true,
        selected: false,
      },
      {
        id: 6,
        title: 'مانجو سلطة',
        titleEn: 'Mango Salad',
        description: 'خس عربي، مانجو، جرجير صغير، خس أمريكي، أفوكادو، وتشيكن بوبس.',
        image: '../../img/food/Mango.jpg',
        price: 35,
        calories: 175,
        available: true,
        selected: false,
      },
    ]
  },
  {
    id: 5,
    title: 'المقبلات - Appetizers',
    image: '../../../img/list/goong.png',
    selected: false,
    items: [
      {
        id: 1,
        title: 'أصابع الموتزاريلا المقلية',
        titleEn: 'Fried Mozzarella Sticks',
        description: 'أصابع جبنة الموتزاريلا المقلية، تقدم مع صوص الطماطم أو صوص الثوم لتجربة لذيذة مليئة بالنكهات.',
        image: '../../img/food/fried-mozzarella-sticks.jpg',
        price: 33,
        calories: 320,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'دايناميت شريمب',
        titleEn: 'Dynamite Shrimp',
        description: 'روبيان مغطى بطبقة مقرمشة، مقلي حتى يصبح ذهبي اللون، يقدم مع صوص حار أو صوص مايونيز حسب الذوق.',
        image: '../../img/food/dynamite-shrimp.jpg',
        price: 49,
        calories: 450,
        available: true,
        selected: false,
      },
      {
        id: 3,
        title: 'بروشيتا بالخضار',
        titleEn: 'Bruschetta Vegetable',
        description: '',
        image: '../../img/food/bruschetta-vegetable.jpg',
        price: 25,
        calories: 200,
        available: true,
        selected: false,
      },
      {
        id: 4,
        title: 'بطاطس مقلي',
        titleEn: 'French Fries',
        description: '',
        image: '../../img/food/french-fries.jpg',
        price: 17,
        calories: 250,
        available: true,
        selected: false,
      },
      {
        id: 5,
        title: 'بطاطس مقلية بالجبن',
        titleEn: 'Cheese Fries',
        description: 'بطاطس مقلية ذهبية، مغطاة بجبنة سائلة ومذابة، تقدم مع صوصات مختلفة لتزيد من طعمها اللذيذ.',
        image: '../../img/food/cheese-fries1.jpg',
        price: 28,
        calories: 300,
        available: true,
        selected: false,
      },
      {
        id: 6,
        title: 'بطاطس مقلي بصوص جبنة مدخن وبيف بيكون',
        titleEn: 'Cheese Fries with Smoked Bacon',
        description: 'بطاطس بوم فريت، صوص تكسس، جبنة شيد امركن، حليب، بيف بيكون، هلبينو، سويت ريلش.',
        image: '../../img/food/cheese-fries-smoked-bacon.jpg',
        price: 32,
        calories: 380,
        available: true,
        selected: false,
      },
    ]
  },
  {
    id: 6,
    title: 'البرجر - Burger',
    image: '../../../img/list/sandwich.png',
    selected: false,
    items: [
      {
        id: 10,
        title: 'w5 برجر روبيان',
        titleEn: 'W5 SHRIMP BURGER',
        description: 'اسماش برجر لحم مع الروبيان المشوي والبصل المكرمل والمشروم والخيار الحلو .',
        image: '../../img/food/shrimp-porg.jpeg',
        price: 45,
        calories: 620,
        available: true,
        isNew: true,
        selected: false,
      },
      {
        id: 1,
        title: 'جريلد تشيكن برجر',
        titleEn: 'Grilled Chicken Burger',
        description: 'دجاج جريلد مع بسترامي مدخن وصوص التكساس ، مع البطاطس المقلية.',
        image: '../../img/food/1.jpg',
        price: 42,
        calories: 520,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'دجاج كلاسك برجر',
        titleEn: 'Classic Chicken Burger',
        description: 'دجاج مفروم بخلطة دبليو فايف السرية مع صوص ساوزن آيلاند وشريحة جبنة.',
        image: '../../img/food/2.jpg',
        price: 42,
        calories: 490,
        available: true,
        selected: false,
      },
      {
        id: 3,
        title: 'هواي برجر',
        titleEn: 'Hawaii Burger',
        description: 'خبز البرجر مع بريسكت لحم، والبيكون و صوص البرجر و شرائح الأناناس والبصل المكرمل.',
        image: '../../img/food/3.jpg',
        price: 42,
        calories: 530,
        available: true,
        selected: false,
      },
      {
        id: 4,
        title: 'لحم كلاسك برجر',
        titleEn: 'Classic Beef Burger',
        description: 'خبز البرجر مع سماش لحم، شريحة جبنة، صوص البرجر، ويُقدَّم مع البطاطس المقلية.',
        image: '../../img/food/4.jpg',
        price: 42,
        calories: 500,
        available: true,
        selected: false,
      },
      {
        id: 5,
        title: 'كريسبي سبايسي تشيكن برجر',
        titleEn: 'Crispy Spicy Chicken Burger',
        description: 'دجاج مقلي مع صوص سبايسي دبليو فايف ويُقدَّم مع البطاطس المقلية.',
        image: '../../img/food/5.jpg',
        price: 42,
        calories: 490,
        available: true,
        selected: false,
      },
      {
        id: 6,
        title: 'ترافل برجر',
        titleEn: 'Truffle Burger',
        description: 'خبز البرجر مع لحم بريسكت، بصل مكرمل والبيكون، بصل مخلل، هالابينو المقلي وصوص الترافل.',
        image: '../../img/food/6.jpg',
        price: 42,
        calories: 650,
        available: true,
        selected: false,
      },
      {
        id: 7,
        title: 'كرانشي برجر',
        titleEn: 'Crunchy Burger',
        description: 'خبز البرجر مع سماش لحم، بطاطس كرانشي، صوص الباربيكيو ومايونيز.',
        image: '../../img/food/7.jpg',
        price: 42,
        calories: 560,
        available: true,
        selected: false,
      },
      {
        id: 8,
        title: 'تشيز كلاسيك برجر',
        titleEn: 'Classic Cheese Burger',
        description: 'خبز البرجر مع سماش لحم، شريحة جبنة، صوص البرجر، ويُقدَّم مع البطاطس المقلية غرقانة في صوص الجبنة.',
        image: '../../img/food/8.jpg',
        price: 44,
        calories: 650,
        available: true,
        selected: false,
      },
      {
        id: 9,
        title: ' كرسبي برجر تشيكن',
        titleEn: 'Crispy Chicken Burger',
        description: 'خبز البرجر مع دجاج كريسبي وصوص البرجر والبطاطس المقلية.',
        image: '../../img/food/9.jpg',
        price: 42,
        calories: 620,
        available: true,
        selected: false,
      },
    ]
  },
  {
    id: 7,
    title: 'الحلويات - Sweets',
    image: '../../../img/list/soit.png',
    selected: false,
    items: [
      {
        id: 12,
        title: 'فونتانا كيك',
        titleEn: 'Fontana Cake',
        description: 'طبقة من الموس الشوكوليت مع طبقه من البراونيز و صوص الكراميل',
        image: '../../img/food/fontana.jpg',
        price: 28,
        calories: 420,
        available: true,
        isNew: true,
        selected: false,
      },
      {
        id: 1,
        title: 'لندن كيك',
        titleEn: 'London Cake',
        description: 'كيكة الشوكولاتة مع الغاناش و الكراميل المملح',
        image: '../../img/food/London.jpeg',
        price: 25,
        calories: 355,
        available: true,
        isNew: true,
        selected: false,
      },
      {
        id: 2,
        title: 'موهيتو كيك',
        titleEn: 'Mokito Cake',
        description: 'هي كيكة صيفية منعشة تجمع بين نكهات الليمون الحامض والنعناع',
        image: '../../img/food/mjotocack.jpeg',
        price: 25,
        calories: 355,
        available: true,
        isNew: true,
        selected: false,
      },
      {
        id: 3,
        title: 'كيكة الجزر',
        titleEn: 'Carrot Cake',
        description: 'طبقات من كيكة الجزر مع كريمة الشيز باتر',
        image: '../../img/food/Carrot.jpg',
        price: 25,
        calories: 355,
        available: true,
        selected: false,
      },
      {
        id: 4,
        title: 'كيكة شوكلاتة دبي',
        titleEn: 'Dubai Chocolate Cake',
        description: 'طبقات من الكيك الشوكلاتة مع الكنافة بحشوة البيستاشيو',
        image: '../../img/food/Dubai.jpg',
        price: 25,
        calories: 447,
        available: true,
        selected: false,
      },
      {
        id: 5,
        title: 'التراميسو',
        titleEn: 'Tiramisu',
        description: 'اصابع البسكويت مع كريمة الماسكروبون الايطالية مغطاة بابودرة الكاكاو',
        image: '../../img/food/Tiramisu.jpg',
        price: 24,
        calories: 380,
        available: true,
        selected: false,
      },
      {
        id: 6,
        title: 'ديلات كيك',
        titleEn: 'Delight Cake',
        description: 'كيك الشوكلاتة مع كريمة طعمة المارس والصوص والمكسرات ',
        image: '../../img/food/Delat.jpg',
        price: 24,
        calories: 420,
        available: true,
        selected: false,
      },
      {
        id: 7,
        title: 'سمورز براونيز',
        titleEn: 'Smores Brownies',
        description: 'براونيز بالشوكولاتة الداكنة مع الزبدة والبيض والدقيق والسكر والمارشميلو والنوتيلا والآيس كريم والشوكولاتة البيضاء',
        image: '../../img/food/smores-brownies.jpg',
        price: 27,
        calories: 520,
        available: true,
        selected: false,
      },
      {
        id: 8,
        title: 'سمورز كوكيز',
        titleEn: 'Smores Cookies',
        description: 'كوكيز بالسكر والبيض والبيكنج بودر والدقيق والدقيق الذرة والفانيليا السائلة والشوكولاتة الداكنة وزبدة الفول السوداني والمارشميلو والآيس كريم والنوتيلا',
        image: '../../img/food/smores-cookies.jpg',
        price: 27,
        calories: 480,
        available: true,
        selected: false,
      },
      {
        id: 9,
        title: 'تشيز كيك بيكان كراميل',
        titleEn: 'Pecan Caramel Cheesecake',
        description: 'بسكويت مع كريمه الجبن وصوص الكراميل والبيكان المقرمش مع الآيس كريم',
        image: '../../img/food/bkyancheez.jpg',
        price: 27,
        calories: 465,
        available: true,
        selected: false,
      },
      {
        id: 10,
        title: 'كنافة بالجنبة',
        titleEn: 'Kunafa Cheese',
        description: 'عجينة الكنافة بالزبدة مع طبقة التشيز في الوسط',
        image: '../../img/food/iftar-kunafa-cheese.jpg',
        price: 23,
        calories: 380,
        available: true,
        selected: false,
      },
      {
        id: 11,
        title: 'كنافة قشطة',
        titleEn: 'Kunafa Kashta',
        description: 'عجينة الكنافة مع الزبدة مع قشطة الخاصة',
        image: '../../img/food/iftar-kunafa-kashta.jpg',
        price: 23,
        calories: 370,
        available: true,
        selected: false,
      },
      {
        id: 12,
        title: 'كنافة نوتيلا',
        titleEn: 'Kunafa Nutella',
        description: 'عجينة الكنافة والزبدة مع طبقة من النوتيلا في الوسط',
        image: '../../img/food/iftar-kunafa-nutella.jpg',
        price: 23,
        calories: 420,
        available: true,
        selected: false,
      },
    ]
  },
  {
    id: 8,
    title: 'المشروبات الباردة - Cold Drinks',
    image: '../../../img/list/bard.png',
    selected: false,
    items: [
      {
        id: 1,
        title: 'ماتشا فانيليا',
        titleEn: 'Matcha Vanilla',
        description: 'ماتشا بالفانيليا المطحونة مع الحليب المبرد',
        image: '../../img/food/MATCHA1.jpg',
        price: 27,
        calories: 150,
        available: true,
        selected: false,
        isNew: true,
      },
      {
        id: 1,
        title: 'آيس لاتيه',
        titleEn: 'Iced Latte',
        description: 'قهوة لاتيه باردة مع الحليب المبرد، تقدم باردة لتعطيك انتعاشاً ونكهة القهوة الخفيفة.',
        image: '../../img/food/latte.jpg',
        price: 20,
        calories: 150,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'آيس سبانش لاتيه',
        titleEn: 'Iced Spanish Latte',
        description: 'قهوة لاتيه باردة مضاف إليها نكهة الإسبريسو المكثفة مع الحليب المبرد، مثالية لمحبي القهوة القوية مع لمسة من الحلاوة.',
        image: '../../img/food/latte.jpg',
        price: 22,
        calories: 180,
        available: true,
        selected: false,
      },
      {
        id: 3,
        title: 'آيس وايت موكا',
        titleEn: 'Iced White Mocha',
        description: 'قهوة موكا باردة مع حليب مبرد وشوكولاتة بيضاء، للحصول على طعم مميز وشراب غني بالقهوة والشوكولاتة.',
        image: '../../img/food/latte.jpg',
        price: 22,
        calories: 200,
        available: true,
        selected: false,
      },
      {
        id: 4,
        title: 'آيس أمريكانو',
        titleEn: 'Iced Americano',
        description: 'قهوة أمريكانو باردة، تجمع بين قهوة الإسبريسو والماء البارد، لتحصل على طعم قهوة قوي ومنعش.',
        image: '../../img/food/americano.jpg',
        price: 18,
        calories: 90,
        available: true,
        selected: false,
      },
      {
        id: 5,
        title: 'آيس V60 كولومبيا',
        titleEn: 'Iced V60 Colombia',
        description: 'قهوة كولومبية باردة تم تحضيرها بأسلوب V60، تتميز بنكهة متوازنة وحموضة معتدلة.',
        image: '../../img/food/americano.jpg',
        price: 18,
        calories: 100,
        available: true,
        selected: false,
      },
      {
        id: 6,
        title: 'آيس V60 كولومبيا فروتي',
        titleEn: 'Iced V60 Colombia Fruity',
        description: 'قهوة كولومبية باردة بأسلوب V60، مع نكهة فواكه خفيفة تعزز من حموضة القهوة الطبيعية.',
        image: '../../img/food/americano.jpg',
        price: 20,
        calories: 110,
        available: true,
        selected: false,
      },
      {
        id: 7,
        title: 'آيس V60 إثيوبيا',
        titleEn: 'Iced V60 Ethiopia',
        description: 'قهوة إثيوبية باردة مُحضَّرة بأسلوب V60، مع نكهة زهرية وحموضة خفيفة، مثالية لمحبي النكهات الفريدة.',
        image: '../../img/food/americano.jpg',
        price: 20,
        calories: 90,
        available: true,
        selected: false,
      },
      {
        id: 8,
        title: 'بيستاشيو بارد',
        titleEn: 'Ice Pistachio',
        description: 'صوص بستاشيو، إسبرسو، حليب مكثف نستلة، حليب.',
        image: '../../img/food/ice-pistachio.jpg',
        price: 27,
        calories: 200,
        available: true,
        selected: false,
      },
      {
        id: 9,
        title: 'سجنيتشر بارد',
        titleEn: 'Ice Signature',
        description: 'شراب اللافندر، صوص بستاشيو، حليب مكثف نستلة، إسبرسو، حليب.',
        image: '../../img/food/ice-signature.jpg',
        price: 29,
        calories: 220,
        available: true,
        selected: false,
      },
      {
        id: 10,
        title: 'ماكياتو كاراميل بارد',
        titleEn: 'Ice Caramel Macchiato',
        description: 'شراب الفانيليا، إسبرسو، حليب، شراب سولتد كراميل.',
        image: '../../img/food/ice-caramel-macchiato.jpg',
        price: 24,
        calories: 180,
        available: true,
        selected: false,
      },
      {
        id: 11,
        title: 'افوكاتو اسبريسو',
        titleEn: 'Affogato Espresso',
        description: 'اسبريسو مع آيس كريم الفانيليا والمكسرات والمارشميلو',
        image: '../../img/food/affogato-espresso.jpg',
        price: 20,
        calories: 180,
        available: true,
        selected: false,
      },
    ]
  },
  {
    id: 9,
    title: 'المشروبات الساخنة - Hot Drinks',
    image: '../../../img/list/coffe-cup.png',
    selected: false,
    items: [
      {
        id: 1,
        title: 'فلات وايت',
        titleEn: 'Flat White',
        description: 'مزيج من الإسبريسو وحليب بخاري كثيف، يقدم بطبقة خفيفة من الرغوة، مثالي لمحبي القهوة القوية بحلاوة معتدلة.',
        image: '../../img/food/hot1.jpg',
        price: 20,
        calories: 180,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'إسبريسو',
        titleEn: 'Espresso',
        description: 'شوت من القهوة المركزة القوية، يقدم في فنجان صغير لذوي الذوق القوي والذين يحبون طعم القهوة النقي.',
        image: '../../img/food/hot2.jpg',
        price: 15,
        calories: 60,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'قهوة تركي',
        titleEn: 'Turkish Coffee',
        description: 'قهوة تركية أصيلة محضرة بالطريقة التقليدية، تتميز برغوة كثيفة ونكهة قوية وعميقة',
        image: '../../img/food/turkysh.jpg',
        price: 15,
        calories: 60,
        available: true,
        selected: false,
      },
      {
        id: 3,
        title: 'كورتادو',
        titleEn: 'Cortado',
        description: 'إسبريسو مع كمية متساوية من الحليب المبخر، مشروب متوسط القوة مع ملمس ناعم.',
        image: '../../img/food/hot3.jpg',
        price: 16,
        calories: 120,
        available: true,
        selected: false,
      },
      {
        id: 4,
        title: 'كافي لاتيه',
        titleEn: 'Caffè Latte',
        description: 'إسبريسو مع حليب مبخر ورغوة خفيفة، مشروب مفضل للأشخاص الذين يحبون القهوة بنكهة حليبية.',
        image: '../../img/food/hot4.jpg',
        price: 20,
        calories: 180,
        available: true,
        selected: false,
      },
      {
        id: 5,
        title: 'أمريكانو',
        titleEn: 'Americano',
        description: 'إسبريسو مع ماء ساخن، مشروب مثالي لمحبي القهوة الخفيفة القوية الطعم بدون حليب.',
        image: '../../img/food/hot5.jpg',
        price: 18,
        calories: 90,
        available: true,
        selected: false,
      },
      {
        id: 6,
        title: 'كافي موكا',
        titleEn: 'Caffè Mocha',
        description: 'إسبريسو مع شوكولاتة ساخنة وحليب، يقدم مع رغوة كريمية لمذاق غني وملموس.',
        image: '../../img/food/hot6.jpg',
        price: 24,
        calories: 220,
        available: true,
        selected: false,
      },
      {
        id: 7,
        title: 'شوكولاتة ساخنة',
        titleEn: 'Hot Chocolate',
        description: 'مشروب الشوكولاتة الساخنة الكريمي، يقدم مع كريمة مخفوقة أو مكعبات مارشميلو على الوجه.',
        image: '../../img/food/hot7.jpg',
        price: 18,
        calories: 210,
        available: true,
        selected: false,
      },
      {
        id: 8,
        title: 'شوكولاتة ساخنة بالبندق',
        titleEn: 'Hazelnut Hot Chocolate',
        description: 'بودرة شوكلت، شراب البندق، سكر، حليب.',
        image: '../../img/food/hazelnut-hot-chocolate.jpg',
        price: 27,
        calories: 250,
        available: true,
        selected: false,
      },
      {
        id: 9,
        title: 'كاراميل ماكياتو',
        titleEn: 'Caramel Macchiato',
        description: 'إسبريسو مع حليب مبخر وصوص الكراميل، مشروب حلو ومر في آن واحد.',
        image: '../../img/food/hot8.jpg',
        price: 25,
        calories: 220,
        available: true,
        selected: false,
      },
      {
        id: 10,
        title: 'ڤي 60 أثيوبي حار',
        titleEn: 'Hot V60 Ethiopia',
        description: '',
        image: '../../img/food/hot-v60-ethiopia.jpg',
        price: 20,
        calories: 90,
        available: true,
        selected: false,
      },
      {
        id: 11,
        title: 'ڤي 60 كولومبي حار',
        titleEn: 'Hot V60 Colombia',
        description: '',
        image: '../../img/food/hot-v60-colombia.jpg',
        price: 20,
        calories: 90,
        available: true,
        selected: false,
      },
      {
        id: 12,
        title: 'ڤي 60 كولومبي بنكهة الفواكه حار',
        titleEn: 'Hot V60 Colombia Fruity',
        description: '',
        image: '../../img/food/hot-v60-colombia-fruity.jpg',
        price: 25,
        calories: 100,
        available: true,
        selected: false,
      },
      {
        id: 13,
        title: 'سبانش لاتيه',
        titleEn: 'Spanish Latte',
        description: 'حليب مكثف نستلة، إسبرسو، حليب.',
        image: '../../img/food/spanish-latte.jpg',
        price: 24,
        calories: 200,
        available: true,
        selected: false,
      },
      {
        id: 14,
        title: 'لاتيه البندق',
        titleEn: 'Hazelnut Latte',
        description: 'شراب البندق، إسبرسو، حليب.',
        image: '../../img/food/hazelnut-latte.jpg',
        price: 27,
        calories: 220,
        available: true,
        selected: false,
      },
      {
        id: 15,
        title: 'ليبتون شاي',
        titleEn: 'Lipton Tea',
        description: '',
        image: '../../img/food/lipton-tea.jpg',
        price: 6,
        calories: 50,
        available: true,
        selected: false,
      },
      {
        id: 17,
        title: 'كابتشينو',
        titleEn: 'Cappuccino',
        description: 'حليب، إسبرسو.',
        image: '../../img/food/cappuccino.jpg',
        price: 20,
        calories: 180,
        available: true,
        selected: false,
      },
      {
        id: 16,
        title: 'قهوه سعودية',
        titleEn: 'Arabic Coffee',
        description: '',
        image: '../../img/food/arabic-coffee.jpg',
        price: 32,
        calories: 80,
        available: true,
        selected: false,
      },
    ]
  },
  {
    id: 10,
    title: 'العصائر الطازجة - Fresh Juices',
    image: '../../../img/list/iced-coffee.png',
    selected: false,
    items: [
      {
        id: 1,
        title: 'عصير تفاح موز',
        titleEn: 'Apple Banana Juice',
        description: 'عصير طازج من التفاح والموز الممزوج، يقدم لك نكهة حلوة ومنعشة مع قوام كريمي.',
        image: '../../img/food/apple.jpg',
        price: 25,
        calories: 150,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'عصير W5 كوكتال',
        titleEn: 'W5 Cocktail Juice',
        description: 'مزيج من الفواكه الطازجة واللذيذة (تفاح، برتقال، موز)، يقدم طعماً منعشاً وملئاً بالعناصر الغذائية.',
        image: '../../img/food/cocktail.jpg',
        price: 27,
        calories: 180,
        available: true,
        selected: false,
      },
      {
        id: 3,
        title: 'عصير أفوكادو',
        titleEn: 'Avocado Juice',
        description: 'عصير أفوكادو طازج مع لمسة من الحليب أو عصير الليمون، مشروب غني بالكريمة والفوائد الصحية.',
        image: '../../img/food/avocado.jpg',
        price: 25,
        calories: 200,
        available: true,
        selected: false,
      },
      {
        id: 4,
        title: 'عصير برتقال',
        titleEn: 'Orange Juice',
        description: 'عصير برتقال طبيعي طازج، يقدم لك نكهة حامضة منعشة وغنية بفيتامين C لتعزيز الطاقة.',
        image: '../../img/food/orange.jpg',
        price: 25,
        calories: 120,
        available: true,
        selected: false,
      },
      {
        id: 5,
        title: 'عصير ليمون ونعناع',
        titleEn: 'Lemon Mint Juice',
        description: 'عصير ليمون طازج مع نعناع مفروم، مشروب مثالي للانتعاش في أيام الصيف الحارة، غني بالحموضة والنكهة العطرية.',
        image: '../../img/food/lemon.jpg',
        price: 20,
        calories: 100,
        available: true,
        selected: false,
      },
      {
        id: 6,
        title: 'ليمون وردي',
        titleEn: 'Pink Lemonade',
        description: 'عصير ليمون طازج، شراب الفراولة، سكر، تقدم مع شريحة ليمون للتزيين.',
        image: '../../img/food/limon-wrdi.jpg',
        price: 20,
        calories: 120,
        available: true,
        selected: false,
      },
    ]
  },
  {
    id: 11,
    title: 'الموهيتو - Mojito',
    image: '../../../img/list/moheto5a9.png',
    selected: false,
    items: [
      {
        id: 1,
        title: 'فيرجن موهيتو',
        titleEn: 'Virgin Mojito',
        description: 'مشروب منعش وخالي من الكحول يتكون من نعناع طازج، عصير ليمون، وسكر بسيط، يُقدَّم مع قطع ثلج لإضفاء الانتعاش.',
        image: '../../img/food/virgin.jpg',
        price: 22,
        calories: 120,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'W5 موهيتو',
        titleEn: 'W5 Mojito',
        description: 'نسخة مبتكرة من الموهيتو، تجمع بين النعناع الطازج وعصير الليمون مع إضافة مكونات خاصة من خلطة W5 السرية، مشروب منعش وغني بالنكهة.',
        image: '../../img/food/w5mojito.jpg',
        price: 25,
        calories: 130,
        available: true,
        selected: false,
      },
      {
        id: 3,
        title: 'فراولة موهيتو',
        titleEn: 'Strawberry Mojito',
        description: 'موهيتو بالفراولة الطازجة الممزوجة مع عصير الليمون والنعناع، يقدم طعماً فاكهياً مميزاً ومنعشاً.',
        image: '../../img/food/strawberry.jpg',
        price: 22,
        calories: 150,
        available: true,
        selected: false,
      },
      {
        id: 4,
        title: 'كلاسيك موهيتو',
        titleEn: 'Classic Mojito',
        description: 'النسخة التقليدية من الموهيتو، مع النعناع الطازج وعصير الليمون والسكر، مشروب منعش وحامض يتناغم مع نكهة النعناع.',
        image: '../../img/food/classic.jpg',
        price: 22,
        calories: 120,
        available: true,
        selected: false,
      },
      {
        id: 5,
        title: 'موهيتو مرجريتا كوكتيل',
        titleEn: 'Menta Rita',
        description: 'موهيتو موكتيل، كوكتيل مارغريتا، ليمون أخضر، بذور الشيا، نعناع، مياه غازية، خالي من السكر.',
        image: '../../img/food/menta-rita.jpg',
        price: 22,
        calories: 140,
        available: true,
        selected: false,
      },
      {
        id: 6,
        title: 'مشروب طاقة مع فراولة',
        titleEn: 'Amarito Fragola',
        description: 'شراب مشروب الطاقة، شراب الفراولة، ليمون أخضر، بذور الشيا، نعناع، مياه غازية، خالي من السكر.',
        image: '../../img/food/amarito-fragola.jpg',
        price: 18,
        calories: 120,
        available: true,
        selected: false,
      },
      {
        id: 7,
        title: 'توت أزرق إيطالي',
        titleEn: 'Mirtilla Italiano',
        description: 'التوت الأزرق الإيطالي، ليمون أخضر، بذور الشيا، نعناع، مياه غازية، خالي من السكر.',
        image: '../../img/food/mirtilla-italiano.jpg',
        price: 22,
        calories: 130,
        available: true,
        selected: false,
      },
      {
        id: 8,
        title: 'مشروب طاقة إيطالي',
        titleEn: 'Amarito',
        description: 'شراب مشروب الطاقة، ليمون أخضر، بذور الشيا، نعناع، المياه الغازية، خالي من السكر.',
        image: '../../img/food/amarito.jpg',
        price: 18,
        calories: 120,
        available: true,
        selected: false,
      },
      {
        id: 9,
        title: 'تفاح أخضر',
        titleEn: 'Fresca Mela',
        description: 'التفاح الأخضر الإيطالي، ليمون أخضر، بذور الشيا، نعناع، المياه الغازية، خالي من السكر.',
        image: '../../img/food/fresca-mela.jpg',
        price: 22,
        calories: 130,
        available: true,
        selected: false,
      },
      {
        id: 10,
        title: 'زنجبيل مع ليمون',
        titleEn: 'Vita Pura',
        description: 'الزنجبيل والليمون، ليمون أخضر، بذور الشيا، نعناع، المياه الغازية، خالي من السكر.',
        image: '../../img/food/vita-pura.jpg',
        price: 22,
        calories: 110,
        available: true,
        selected: false,
      },
    ]
  },
  {
    id: 12,
    title: 'المشروبات الغازية - Soft Drinks',
    image: '../../../img/list/ghas.png',
    selected: false,
    items: [
      {
        id: 1,
        title: 'بيبسي',
        titleEn: 'Pepsi',
        description: '',
        image: '../../img/food/pepsi.jpg',
        price: "5.50",
        calories: 150,
        available: true,
        selected: false,
      },
      {
        id: 2,
        title: 'سفن أب',
        titleEn: '7 Up',
        description: '',
        image: '../../img/food/7up.jpg',
        price: "5.50",
        calories: 140,
        available: true,
        selected: false,
      },
      {
        id: 3,
        title: 'مياة معدنية',
        titleEn: 'Mineral Water',
        description: '',
        image: '../../img/food/mineral-water.jpg',
        price: 4,
        calories: "0",
        available: true,
        selected: false,
      },
    ]
  },
]